<template>
    <section class="content">
        <div class="container-fluid">
            <api-log v-if="$gate.isAdmin()" ref="requestlog" :limit="10" :paginate="true"></api-log>
        </div>
    </section>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        return {
            LoadAreaData: {},
            CurrentTimestamp: 0,
            timestampStatus: '',
            storeStatus: null,
        }
    },
    methods: {
        refresh() {
            if (this.$refs.requestlog) {
                this.$refs.requestlog.refresh();
            }
        },
        prepareComponent() {
            this.fetchData();
        },
        async fetchData() {
            try {
                const response = await axios.get('api/get_all');
                this.LoadAreaData = response.data;
                this.CurrentTimestamp = moment().unix();
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
    },
    mounted() {
        this.prepareComponent();
    }
}
</script>
